import React from 'react';
import * as Filestack from "filestack-js";

import Blitline from "@helpers/blitline";
import FilestackUploader from '@components/common/filestack_uploader/main';
import { Loader } from '@components/common/loader/main';
import getSimilarity from '@api/services/similarity';

import './styles/similarity.scss';

const filestackOptions = {
  security: BFG.filestack.signature_object,
  cname: BFG.filestack.cname
};
const filestack = Filestack.init(BFG.filestack.API_KEY, filestackOptions);

class Similarity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      url1: null,
      url2: null,
      score: null,
      difference: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { url1, url2 } = this.state;
    const newImg1 = prevState.url1 !== url1;
    const newImg2 = prevState.url2 !== url2;

    if (url1 && url2 && (newImg1 || newImg2)) {
      this.setState({ loading: true }); // eslint-disable-line react/no-did-update-set-state
      getSimilarity(url1, url2).then(({ score, difference }) => {
        this.setState({
          score,
          difference,
          loading: false,
        });
      });
    }
  }

  onUpload = (id) => {
    const key = `url${id}`;

    return (files) => {
      this.setState({
        error: false,
        score: null,
        difference: null,
      });

      const url = files.filesUploaded[0].url;
      const urlParts = url.split("/");
      const handle = urlParts[urlParts.length - 1];
      const requiredInfo = {
        filename: true,
        mimetype: true,
        width: true,
        height: true,
      };

      filestack.metadata(handle, requiredInfo).then((_file) => {
        const file = _file;
        file.filetype = Blitline.normalizeFiletype(file.mimetype.split("/")[1]);
        file.url = url;

        if (!file.width || !file.height || !Blitline.hasSupportFor(file.filetype)) {
          this.setState({ error: 'File type not supported.' });
          return;
        }

        if (!Blitline.webViewable(file.filetype)) {
          const blitline = new Blitline(file.url, file.filetype);
          blitline.thumbnail()
            .then((thumbnailUrl) => this.setState({ [key]: thumbnailUrl }))
            .catch((error) => {
              this.setState({ error });
            });
        } else {
          this.setState({ [key]: file.url });
        }
      });
    };
  }

  reset = () => {
    this.setState({
      url1: null,
      url2: null,
      error: false,
      score: null,
      difference: null,
      loading: false,
    });
  }

  renderResetButton() {
    const { url1, url2 } = this.state;
    if (!url1 && !url2) { return undefined; }

    return (
      <button
        className="workbench__reset-button"
        onClick={this.reset}
        type="button"
      >
        <span className="bff-refresh" />
        Start over
      </button>
    );
  }

  renderScores() {
    const { score, difference } = this.state;
    if (score === null) { return null; }

    return (
      <div className="workbench-similarity__scores">
        {(difference === undefined) ? <h2>It’s a match! No difference.</h2>
          : (
            <div>
              <h1>{difference}% difference</h1>
              <p>The difference calculator analyzes changes in the logo structures, layouts, gradients, colors, opacities, etc.</p>
            </div>
          )
        }
      </div>
    );
  }

  renderLoader() {
    if (!this.state.loading) { return null; }

    return (
      <React.Fragment>
        <Loader />
        <p>Calculating similarity...</p>
      </React.Fragment>
    );
  }

  renderImage(id) {
    const url = this.state[`url${id}`];
    const dropzoneId = `filestack-dropzone-${id}`;
    return (
      <div
        className="workbench-similarity__image"
        key={id}
      >
        {url ? (
          <img src={url} />
        ) : (
          <React.Fragment>
            <FilestackUploader
              type="area"
              options={{ maxFiles: 1 }}
              onSuccess={this.onUpload(id)}
              onError={(file, error) => this.onUploadError(file, error)}
              dropzoneContainerId={dropzoneId}
            />
            <div
              className="workbench-similarity__image-dropzone"
              id={dropzoneId}
            />
          </React.Fragment>
        )}
      </div>
    );
  }

  renderError() {
    const { error } = this.state;

    if (!error) { return undefined; }

    return (
      <p className="workbench__error">
        {error}
      </p>
    );
  }

  render() {
    return (
      <div className="workbench-similarity">
        <div className="workbench-similarity__images">
          {this.renderImage(1)}
          <h3>vs.</h3>
          {this.renderImage(2)}
        </div>
        {this.renderError()}
        {this.renderLoader()}
        {this.renderScores()}
        {this.renderResetButton()}
        {this.renderResetButton()}
      </div>
    );
  }
}

export default Similarity;
